// @ts-nocheck
/* eslint-disable */

  /**
  * Do not change! File was auto generate. 
  *
  */
  
import React from 'react';

import { ReactComponent as ExtensionComponent} from './Extension.svg';

import Icon, { TIconProps } from '../Icon';

export const IconExtension = React.forwardRef<any, TIconProps>((props, ref) => (
  <Icon
    ref={ref}
    {...props}
  >
    <ExtensionComponent/>
  </Icon>
));
